import router from '@/core/router';
import type { AppModule } from '@ohmybible/core';

const registerModule = (name: string, module: AppModule) => {
  if (module.routes) {
    for (const route of Object.values(module.routes)) {
      router.addRoute(route);
    }
  }

  console.info(`Module "${name.replace(/Module$/, '')}" registered successfully`);
};

export const registerModules = (modules: Record<string, AppModule>) => {
  Object.entries(modules).forEach(([moduleKey, module]) => {
    if (module) {
      registerModule(moduleKey, module);
    }
  });
};
